import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Course::VisualizeVocabularies @model={{@model}} />\n\n", {
  moduleName: "ilios-common/templates/course-visualize-vocabularies.hbs"
});